module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('PolicyButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "refresh": function($event) {
        return _vm.$emit('refresh')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("P" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._l((_vm.item.configuration), function(conf, key) {
    return _c('div', {
      staticClass: "column shrink"
    }, [(key === 'max_bookable' || key === 'min_bookable') ? _c('div', {
      staticClass: "bookable"
    }, [_c('div', [_vm._v(_vm._s(key.replace('_', ' ')))]), _c('div', [_vm._v(_vm._s(conf))])]) : _vm._e(), (key === 'booking_days') ? _c('div', {
      staticClass: "booking_days"
    }, [_c('div', [_vm._v("Booking Days")]), _vm._l((conf), function(c) {
      return _c('span', [_vm._v(_vm._s(c) + " ")])
    })], 2) : _vm._e()])
  })], 2)]) : _vm._e(), (_vm.$is('entity-policy')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("P" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Type")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.type))])]), _vm._l((_vm.item.configuration), function(conf, key, i) {
    return _c('div', {
      staticClass: "column"
    }, [_c('div', [_vm._v(_vm._s(key))]), (typeof conf === 'number') ? _c('div', [_vm._v(_vm._s(conf))]) : _vm._e()])
  })], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-454f6de9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Policy.vue
// module id = 2452
// module chunks = 1